/*
 * @Author: Ashley.Liu
 * @Date: 2022-10-31 16:04:05
 * @LastEditTime: 2022-11-02 13:16:33
 * @Description: desc
 */
export default {
  lineNumbers: true,
  mode: 'text/x-sql',
  theme: 'abcdef',
  readOnly: false,
  keyMap: 'sublime',
  autofocus: false,
  autoRefresh: true,
  lint: false,
}
